import React, { useEffect } from 'react';
import { copyTrackingService } from '@root/services/copyTrackingService';
import { useChatBot } from '@root/context/ChatBotContext';

interface GlobalCopyTrackerProps {
  onOpenViperAI?: (context: any) => void;
}

const GlobalCopyTracker: React.FC<GlobalCopyTrackerProps> = ({ onOpenViperAI = () => {} }) => {
  const { openChatBot } = useChatBot();

  useEffect(() => {
    const handleOpenViperAI = (context: any) => {
      // Create formatted message with context in the requested format
      const contextMessage = `${context.breadcrumb} -> ${context.cardOrTableName}\n\nCopied text: ${context.copiedText}`;
      
      // Open ChatBot with pre-filled context
      openChatBot(contextMessage);
      
      // Call the optional callback if provided
      onOpenViperAI(context);
    };

    const unsubscribe = copyTrackingService.onOpenViperAI(handleOpenViperAI);
    
    return unsubscribe;
  }, [openChatBot, onOpenViperAI]);

  // This component doesn't render anything, it just sets up global listeners
  return null;
};

export default GlobalCopyTracker;
